import * as ActionTypes from "../constants/action-types";

const initialState = {
    accountType:"",
    submitResult: false,
    countryList:[],
    lstCountryMapping:[],
    captcha:"",
    verifyAccountResult:1,
    notConsent:1,
    consentStatusCompleted:false,
    accountTypeCompleted:false,
    accountInfo:{}
};


function hkidrReducer(state = initialState, action) {

    if (action.type === ActionTypes.SUBMIT_HKIDR) {
        return Object.assign({},state,{            
            submitResult: action.payload.result
        });
    }

    if(action.type === ActionTypes.GET_ACCOUNT_TYPE){        
        return Object.assign({},state,{            
            accountType: action.payload,
            accountTypeCompleted:true
        });
    }

    if(action.type === ActionTypes.GET_CAPTCHA){
        return Object.assign({},state,{            
            captcha: action.payload
        });
    }

    if(action.type === ActionTypes.GET_COUNTRY_LIST){        
        return Object.assign({},state,{            
            countryList: action.payload
        });
    }

    if(action.type === ActionTypes.VERIFY_ACCOUNT){             
        return Object.assign({},state,{            
            verifyAccountResult: action.payload,
            
        });
    }

    if(action.type === ActionTypes.GET_CONSENT_STATUS){             
        return Object.assign({},state,{            
            notConsent: action.payload == -1,
            consentStatusCompleted:true
            
        });
    }

    if(action.type === ActionTypes.GET_ACCOUNT_INFO){
        return Object.assign({},state,{            
            accountInfo: action.payload
        });
    }

    return state; 
}

export default hkidrReducer;